import { Loader2 } from "lucide-react";

import { BaseModal } from "../modals/BaseModal";
import type { ChannelOAuthOption } from "../../services/chatbotV2/chatbotV2Service";

type ChannelOAuthPagePickerModalProps = {
  isOpen: boolean;
  title: string;
  options: ChannelOAuthOption[];
  loading?: boolean;
  onClose: () => void;
  onSelect: (option: ChannelOAuthOption) => void;
};

export const ChannelOAuthPagePickerModal = ({
  isOpen,
  title,
  options,
  loading = false,
  onClose,
  onSelect,
}: ChannelOAuthPagePickerModalProps) => (
  <BaseModal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    description={
      <div className="space-y-3 text-left">
        <p className="text-sm text-gray-500">Selecciona la cuenta que quieres conectar con Fluxi.</p>
        <div className="space-y-2">
          {options.map((option) => (
            <button
              key={`${option.page_id}-${option.instagram_business_account_id || ""}`}
              type="button"
              disabled={loading}
              onClick={() => onSelect(option)}
              className="flex w-full items-center justify-between rounded-xl border border-gray-200 bg-white px-3 py-3 text-left text-sm hover:bg-gray-50 disabled:opacity-60"
            >
              <span>
                {option.page_name || option.username || option.page_id}
                {option.username ? ` (@${option.username})` : ""}
              </span>
              {loading ? <Loader2 className="size-4 animate-spin text-gray-400" /> : null}
            </button>
          ))}
        </div>
      </div>
    }
    buttonTwo={{
      text: "Cancelar",
      onClick: onClose,
      variant: "outline",
      disabled: loading,
    }}
  />
);
